import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {UserAlertsContent} from "./UserAlertsContent";
import {LocalStorage} from "../../utils/LocalStorage";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class UserAlertsClass extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulUserUpdated = this.afterSuccessfulUserUpdated.bind(this);
    }

    userId() {
        return LocalStorage.fetchUserId()
    }

    afterSuccessfulUserUpdated() {
        const { t } = this.props;
        alert(t('user.user_updated_successfully'))
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <UserAlertsContent userId={this.props.match.params.id}
                                   afterSuccessfulUserUpdated={this.afterSuccessfulUserUpdated}
                />
            </div>
        )
    }
}

const UserAlerts = withRouterParams(withTranslation()(UserAlertsClass));
export default UserAlerts;
